import { render, staticRenderFns } from "./BlockOffice.vue?vue&type=template&id=ef6a39e6&scoped=true&"
import script from "./BlockOffice.vue?vue&type=script&lang=ts&"
export * from "./BlockOffice.vue?vue&type=script&lang=ts&"
import style0 from "./BlockOffice.vue?vue&type=style&index=0&id=ef6a39e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6a39e6",
  null
  
)

export default component.exports